import SupportViewPage from "./SupportViewPage";

export default SupportViewPage;
